import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { getPrimaryLocation, resolveInvoicePlanLocationId } from '../students/studentsUtils';

const selectLocationsState = createSelector([(state) => state.locations], (locations) => locations ?? {});
const selectSelectedLocation = createSelector([(state) => state.locations], (locations) => locations?.selectedLocation);

export function useLocations() {
  return useSelector(selectLocationsState);
}

export function useSelectedLocation() {
  return useSelector(selectSelectedLocation);
}

export function resolvePlanLocation(locations = [], locationId, student, organizationStudents, rooms) {
  const resolvedLocationId = resolveInvoicePlanLocationId(locationId, student, locations, organizationStudents, rooms);
  return locations.find((location) => location.id === resolvedLocationId) ?? null;
}

// Search the redux store for a location that is marked as 'primary'
// If no primary location is found, return the first location that is marked 'active'
// If no active location is found, return the first location in the list
export function usePrimaryLocation() {
  const locations = useLocations();
  if (!locations) return null;
  return getPrimaryLocation(locations.list);
}
